/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InsiderStatsHistory } from '../models/InsiderStatsHistory';
import type { InsiderStatsHistorySchema } from '../models/InsiderStatsHistorySchema';
import type { InsiderStatsMatchSchema } from '../models/InsiderStatsMatchSchema';
import type { InsiderStatsSchema } from '../models/InsiderStatsSchema';
import type { TimeBucketEnum } from '../models/TimeBucketEnum';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InsiderStatsService {
    /**
     * Register Match Events
     * @param matchId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static registerMatchEventsInsiderStatsRegisterMatchIdPost(
        matchId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/insider_stats/register/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Insider Visits
     * @param lastXDays
     * @returns InsiderStatsSchema Successful Response
     * @throws ApiError
     */
    public static getInsiderVisitsInsiderStatsGet(
        lastXDays?: (number | null),
    ): CancelablePromise<InsiderStatsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider_stats/',
            query: {
                'last_x_days': lastXDays,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Insider Match Visits
     * @param limit
     * @param offset
     * @returns InsiderStatsMatchSchema Successful Response
     * @throws ApiError
     */
    public static getInsiderMatchVisitsInsiderStatsMatchGet(
        limit: number = 100,
        offset?: number,
    ): CancelablePromise<Array<InsiderStatsMatchSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider_stats/match',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Match Visits
     * @param matchId
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getMatchVisitsInsiderStatsMatchMatchIdGet(
        matchId: number,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider_stats/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Insider Stats History
     * @param amountYears
     * @param amountMonths
     * @param amountWeeks
     * @param amountDays
     * @returns InsiderStatsHistorySchema Successful Response
     * @throws ApiError
     */
    public static getInsiderStatsHistoryInsiderStatsHistoryGet(
        amountYears?: number,
        amountMonths?: number,
        amountWeeks?: number,
        amountDays?: number,
    ): CancelablePromise<Array<InsiderStatsHistorySchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider_stats/history',
            query: {
                'amount_years': amountYears,
                'amount_months': amountMonths,
                'amount_weeks': amountWeeks,
                'amount_days': amountDays,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Insider Stats History
     * @param amount
     * @param bucket
     * @returns InsiderStatsHistory Successful Response
     * @throws ApiError
     */
    public static getInsiderStatsHistoryInsiderStatsV2HistoryGet(
        amount: number,
        bucket: TimeBucketEnum,
    ): CancelablePromise<Array<InsiderStatsHistory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/insider_stats/v2/history',
            query: {
                'amount': amount,
                'bucket': bucket,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
